import locale from "../../lib/locales/en.json";

window.I18nlocales = window.I18nlocales || [];
window.I18nlocales.push(locale);
